import React, { useState, useEffect } from 'react';
import GetInTouch from './GetInTouch.tsx';
import AutoplayCarousel from '@/components/Common/AutoplayCarousel';
import { FEATURE_BRANDS } from '@/shared/constants/existing-brands';
import { useWindowSize } from 'react-use';
import './index.less';

const ExistingBrandsHero = () => {
  const { width } = useWindowSize();

  const [isSmallWidth, setIsSmallWidth] = useState<boolean>();

  useEffect(() => {
    if (width < 1024) {
      setIsSmallWidth(true);
    } else {
      setIsSmallWidth(false);
    }
  }, [width]);

  return (
    <div className="existing-brands-hero">
      <div className="existing-brands-container">
        <div className="existing-brands-header">
          <div className="header-content">
            <h1 className="title">
              Save big & grow profitably with <span className="pietra">Pietra</span>
            </h1>
            <p className="description">
              Our membership gives brands access to cost-plus pricing across software, logistics, sourcing, and
              marketing tools.
            </p>
          </div>
          <GetInTouch />
        </div>
        <div className="featured-brands-container">
          {isSmallWidth ? (
            <AutoplayCarousel content={FEATURE_BRANDS} orientation="horizontal" />
          ) : (
            <>
              <AutoplayCarousel content={FEATURE_BRANDS} orientation="vertical" />
              <AutoplayCarousel content={FEATURE_BRANDS} orientation="vertical-reverse" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExistingBrandsHero;
